import api from "./api";

// Get all asset tasks
export async function getAssetTasks() {
  return api.get("/asset-task");
}

// Get asset task by ID
export async function getAssetTaskById(id) {
  if (id == null) throw new Error("Asset task ID is required");
  return api.get(`/asset-task/${id}`);
}

// Create a single asset task
export async function createAssetTask(payload) {
  const body = {
    task_id: payload.task_id != null ? Number(payload.task_id) : null,
    process_id: payload.process_id != null ? Number(payload.process_id) : null,
    type: String(payload.type || "").trim(),
    input: Boolean(payload.input),
    output: Boolean(payload.output),
    description: String(payload.description || "").trim(),
    document_link: payload.document_link
      ? String(payload.document_link).trim()
      : null,
  };
  return api.post("/asset-task", body);
}

// Update asset task
export async function updateAssetTask(id, payload) {
  if (id == null) throw new Error("Asset task ID is required");
  const body = {
    task_id: payload.task_id != null ? Number(payload.task_id) : undefined,
    process_id:
      payload.process_id != null ? Number(payload.process_id) : undefined,
    type: payload.type ? String(payload.type).trim() : undefined,
    input: payload.input !== undefined ? Boolean(payload.input) : undefined,
    output: payload.output !== undefined ? Boolean(payload.output) : undefined,
    description: payload.description
      ? String(payload.description).trim()
      : undefined,
    document_link: payload.document_link
      ? String(payload.document_link).trim()
      : undefined,
  };
  // Remove undefined values
  Object.keys(body).forEach(
    (key) => body[key] === undefined && delete body[key]
  );
  return api.patch(`/asset-task/${id}`, body);
}

// Delete asset task
export async function deleteAssetTask(id) {
  if (id == null) throw new Error("Asset task ID is required");
  return api.delete(`/asset-task/${id}`);
}

// Get process tasks (chain data without creating)
export async function getProcessTasks(processId) {
  if (!processId) throw new Error("Process ID is required");
  return api.get(`/asset-task/chain/${processId}`);
}

// Create chain with manual input
export async function createAssetTaskChain(payload) {
  const body = {
    process_id: payload.process_id != null ? Number(payload.process_id) : null,
    tasks: Array.isArray(payload.tasks)
      ? payload.tasks.map((t) => ({
          task_id: t.task_id != null ? Number(t.task_id) : null,
          type: String(t.type || "").trim(),
          description: String(t.description || "").trim(),
          document_link: t.document_link
            ? String(t.document_link).trim()
            : undefined,
        }))
      : [],
  };
  return api.post("/asset-task/chain", body);
}

// Auto-create chain from database
export async function autoCreateAssetTaskChain(processId) {
  if (!processId) throw new Error("Process ID is required");
  return api.get(`/asset-task/chain/auto/${processId}`);
}

// Get asset tasks by company ID
export async function getAssetTasksByCompanyId(companyId) {
  if (!companyId) throw new Error("Company ID is required");
  return api.get(`/asset-task?companyId=${companyId}`);
}

// Get asset tasks by process ID
export async function getAssetTasksByProcessId(processId) {
  if (!processId) throw new Error("Process ID is required");
  return api.get(`/asset-task?processId=${processId}`);
}
